import * as React from "react";
import { Button } from "@/components/ui/button";
import { Trash } from "lucide-react";
import { useDeleteChronoRecordMutation } from "@/api/chronology";
import TopBarProgress from "react-topbar-progress-indicator";

interface Props {
  id: string;
}

export const ChronologyListRecordDelete: React.FC<Props> = ({ id }) => {
  const [handleDelete, { isLoading }] = useDeleteChronoRecordMutation();

  const handleClick = async () => {
    await handleDelete(id).unwrap();
  };

  return (
    <>
      {isLoading && <TopBarProgress />}
      <Button variant="secondary" size="sm" className="w-full text-xs sm:w-auto" onClick={handleClick}>
        <Trash className="mr-1 h-3 w-3" />
      </Button>
    </>
  );
};
